import React from 'react';
import SubjectPage from '../../subjects/SubjectPage';



function NcertSolutions() {
  
  const pageTitleText = "NEET NCERT Solutions (11 & 12)";


  return (
    <>
     

      <SubjectPage 
        name={pageTitleText} 
        link="ncert-solutions" 
        type="ncertsolution"
      />

    </>
  );
}

export default NcertSolutions;